export const SUPPORTED_SEARCH_COUNTRIES = ["co", "ec", "us"];
